<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="添加表格"
    width="500px"
  >
    <div>
      <el-form :model="dialogFormData" ref="form" label-width="100px" >
       
        <el-form-item
          v-for="(item, index) in dialogFormData.standards"
          :label="'考核标准' + (index+1)"
          :key="item.key"
          :prop="'standards.' + index + '.title'"
          :rules="{
            required: true, message: '考核标准不能为空', trigger: 'blur'
          }"
        >
        <el-col :span="18">
          <el-input v-model="item.title" placeholder="请输入考核标准"></el-input>
        </el-col>
        <el-col :span="6">
          <el-button @click.prevent="removeStandard(item)" v-if="index>0">删除</el-button>
        </el-col>
        </el-form-item>
        <el-form-item>
          <el-button @click="addStandard">新增标准</el-button>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>

export default {

  data() {
    return {
      visible: false,
      dialogFormData: {
        standards:[{
          title: ''
          }]
      },
    };
  },


  destroyed(){
    this.handleClose();
  },
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();

      this.visible = false;

    },


    init(datas) {
      this.visible = true;
      if(datas&&datas.length>0){
        this.dialogFormData.standards=[];
        for (let item of datas) {
          this.dialogFormData.standards.push({
            'title':item.title
          });
        }
      }
    },

    removeStandard(item) {
        var index = this.dialogFormData.standards.indexOf(item)
        if (index !== -1) {
          this.dialogFormData.standards.splice(index, 1)
        }
    },
    addStandard() {
      this.dialogFormData.standards.push({
        title: '',
        key: Date.now()
      });
    },
    
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            that.$emit('initTable',that.dialogFormData.standards);
            that.visible = false;
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
